import Global from "../utils/Global";
import ApiClient from "./ApiClient";

export const updateTimezone = ({ token, data }) => {
  return ApiClient.post('/api/timezones', data, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const updatePassword = ({ token, data }) => {
  return ApiClient.post('/api/users/update_password', data, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const resetPassword = ({ token, data, userId }) => {
  return ApiClient.post('/api/users/reset_password/' + userId, data, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const updateAgent = ({ token, userId, data }) => {
  return ApiClient.put('/api/users/' + userId, data, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const deleteUser = ({ token, userId, }) => {
  return ApiClient.delete('/api/users/' + userId, {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const fetchUsers = async ({ token, page, filterBy, searchQuery, pageSize, userType }) => {
  return await ApiClient.get('/api/users', {
    params: {
      search_query: searchQuery,
      page,
      page_size: pageSize,
      filter_by: filterBy,
      user_type: userType
    },
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}

export const exportUsers = async ({ token, filters }) => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    const response = await fetch(Global.baseURL + `/api/users/export?${queryString}`, {
      method: 'GET',
      headers: {
        "Authorization": "Bearer " + token
      }
    });

    if (!response.ok) {
      throw new Error('Failed to export users');
    }

    return response.blob();
  } catch (error) {
    // Handle error
    console.error('Error exporting users:', error);
    throw error;
  }
}

export const fetchAgentsFromCMS = async ({ token, searchQuery }) => {
  const response = await ApiClient.get('/api/agents', {
    params: {
      search_query: searchQuery,
    },
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });

  return response;
}

export const fetchAllUsers = async ({ token }) => {
  return await ApiClient.get('/api/users/all', {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}